// let API_URL='http://localhost:3038';
let API_URL='https://api-betway-jackpots-staging.betville.io';
if (window.location.href.indexOf("betway-jackpots-prod.") != -1){
    // console.log("PROD-MODE");
    API_URL='https://api-betway-jackpots-prod.betville.io';
}
if (window.location.href.indexOf("betway-jackpots.") != -1){
    // console.log("PROD-MODE");
    API_URL='https://api-betway-jackpots.betville.io';
}
if (window.location.href.indexOf("betway-jackpots-staging") != -1){
    // console.log("STAGE-MODE");
    API_URL='https://api-betway-jackpots-staging.betville.io';
} 
if (window.location.href.indexOf("betway-jackpots-dev") != -1){
    // console.log("STAGE-MODE");
    API_URL='https://api-betway-jackpots-dev.bitville.dev';
}
export {API_URL};


// WEBPACK FOOTER //
// ./api/config.js